import { render, staticRenderFns } from "./personalInfo.vue?vue&type=template&id=6ab97b6d&"
import script from "./personalInfo.vue?vue&type=script&lang=js&"
export * from "./personalInfo.vue?vue&type=script&lang=js&"
import style0 from "./personalInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports